<template>
  <div class="enterprise">
    <div class="header">
      <enterprise-header :key="keyadd"></enterprise-header>
    </div>
    <div class="content">
      <div class="main">
        <div
          style="width:1280px;min-height:808px;background:#ffffffcf;margin:17px auto;margin-bottom:0;border-radius: 4px;margin-bottom: 148px;padding-bottom:20px">
          <img :src="zhuce" alt="" style="margin-top:160px" />
          <p v-if="pagetype == '0'" style="color:#323232;font-size:26px;margin-top:81px">
            您尚无企业信息
          </p>
          <p v-if="pagetype == '0'" style="color:var(--info-color)9;font-size:14px;margin-top:27px">
            请先加入已有企业或创建新企业后，再体验{{ $appTitle }}功能
          </p>
          <div style="margin-top:29px">
            <!-- <el-button type="primary" size="small" plain @click="experienceEnterprise" >体验试用企业</el-button > -->
            <el-button type="primary" size="small" @click="goconsentagree">创建新企业</el-button>
          </div>
          <div v-if="pagetype == '0'" style="margin: 0 auto;margin-top: 63px;">
            <ul>
              <li v-for="(item, index) in nojoinEnterpriseList" :key="index"
                style="color:#7A85A2;text-align: center;font-size: 14px;margin-top:5px;cursor: pointer;margin-top: 10px;">
                <span>企业</span>【{{ item.enterpriseName }}】<span>邀请您加入企业，</span><span class="lijilook"
                  @click="golook(item)">立即查看></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-dialogDrag :visible.sync="dialogVisible" :before-close="handleClose" title="欢迎加入试用企业!" width="427px"
      custom-class="sureExperience-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <p style="margin-bottom:28px;color:var(--theme-color)">
        试用企业每七天自动清理一次试用数据，请及时将有用的信息保存至本地
      </p>
      <p style="margin-bottom:12px;">姓名</p>
      <el-input v-model="nameinput" :disabled="namedisable" placeholder="请输入您的姓名(必填)" size="small"></el-input>
      <p style="margin-top:33px;margin-bottom:12px">企业名称</p>
      <el-input v-model="prjinput" placeholder="请输入您的企业名称" size="small"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" :loading="loadinging" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" :loading="loadinging" type="primary" @click="sureExperience">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EnterpriseHeader from "./components/userEnterHeader";
import enterpriseService from "@/CommonDP/service/enterprise-service";
import registerService from "@/CommonDP/service/register-service";
import loginService from "@/CommonDP/service/login-service";
import { mapState } from "vuex";
import { getToken, storage } from "@/CommonDP/utils";
export default {
  name: "Enterprise",
  components: {
    EnterpriseHeader
  },
  data() {
    return {
      zhuce: require("@/CommonDP/assets/enterprise/kongqiye.png"),
      checked: false,
      pagetype: "0", // 0 就展示您尚无企业信息 就是无企业的状态  1就不展示 代表的是创建新的企业
      dialogVisible: false,
      nameinput: "",
      namedisable: false,
      prjinput: "",
      erpriseList: [],
      loadinging: false,
      nojoinEnterpriseList: [],
      keyadd: 1
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    })
  },
  created() {
    this.pagetype = this.$route.query.pagetype;
    if (this.pagetype === "0") {
      this.quergetInviteJoinEnterpriseList();
    }
    this.queryname();
  },
  methods: {
    queryname() {
      loginService
        .getUserInfo()
        .then((res) => {
          if (res.result === "0") {
            if (res.data.name) {
              this.namedisable = true;
              this.nameinput = res.data.name;
            } else {
              this.namedisable = false;
              this.nameinput = "";
            }
          }
        })
        .catch(() => {});
    },
    // 创建新企业
    goconsentagree() {
      var params = {
        enterpriseName: "",
        creditCode: "",
        userName: "",
        idCard: "",
        verifyCode: "",
        fileList1: [],
        fileList2: []
      };
      storage.set("setenterpriseForm", JSON.stringify(params));
      storage.set("setchecked", JSON.stringify(this.checked));
      // 有enterprisepagetype 就代表是创建企业的页面 不是无企业页面
      if (this.$route.query.pagetype === "1") {
        this.$router.replace({
          path: "/consentagree",
          query: { greetype: "enterprisepage", pagetype: "1" }
        });
      } else {
        // 无企业页面
        this.$router.replace({
          path: "/consentagree",
          query: { greetype: "enterprisepage", pagetype: "0" }
        });
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    sureExperience() {
      if (this.nameinput) {
        this.loadinging = true;
        var data = {
          name: this.nameinput,
          enterpriseName: this.prjinput
        };
        registerService
          .jointrial(data)
          .then((res) => {
            if (res.result === "0") {
              if (!this.namedisable) {
                var data = this.userInfo;
                data.name = this.nameinput;
                data.token = getToken();
                this.$store.dispatch("setUserInfo", data);
                this.$store.commit("SET_NAME", this.nameinput);
                this.keyadd += 1;
              }
              this.loadinging = false;
              this.dialogVisible = false;
              this.$store.dispatch("setUnauthorized", 1);
              this.$store.dispatch("setEnterpriseId", res.data.enterpriseId);
              this.$store.dispatch("setIsTrial", res.data.isTrial);
              this.$router.push({ name: "mainMg" });
            }
          })
          .catch(() => {
            this.loadinging = false;
          });
      } else {
        this.$message.warning("请输入您的姓名");
      }
    },
    experienceEnterprise() {
      enterpriseService.usergetEnterpriseList().then((res) => {
        if (res.result === "0") {
          console.log(res.data, "res.data");
          this.erpriseList = res.data;
          const experiencelist = this.erpriseList.filter((item) => item.isTrial === "1");
          console.log(experiencelist.length);
          if (experiencelist.length === 0) {
            if (!this.namedisable) {
              this.nameinput = "";
            }
            this.prjinput = "";
            this.dialogVisible = true;
          } else {
            this.$store.dispatch("setUnauthorized", 1);
            this.$store.dispatch("setEnterpriseId", experiencelist[0].enterpriseId);
            this.$store.dispatch("setIsTrial", experiencelist[0].isTrial);
            this.$router.push({ name: "mainMg" });
          }
        }
      });
    },
    golook(row) {
      var code = row.inviteCode;
      const { href } = this.$router.resolve({
        path: "/joinEnterprise",
        query: {
          code: code
        }
      });
      window.open(href, "_blank");
    },
    quergetInviteJoinEnterpriseList() {
      registerService
        .getInviteJoinEnterpriseList()
        .then((res) => {
          if (res.result === "0") {
            this.nojoinEnterpriseList = res.data;
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.enterprise {
  min-width: 1000px;
  width: 100%;
  min-height: 937px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 68px;
    line-height: 68px;
    overflow: hidden;
    position: absolute;
    top: 0;
    text-align: center;
    box-sizing: border-box;
  }
  .content {
    position: absolute !important;
    position: relative;
    top: 68px !important;
    bottom: 0px;
    width: 100%;
    overflow: hidden;
    height: auto !important;
    left: 0px;
  }
  .main {
    height: 100%;
    min-height: 1070px;
    overflow-y: auto;
    text-align: center;
    background: url("../../assets/enterprise/qiye.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    .lijilook {
      color: var(--theme-color);
    }
  }
  /deep/ .sureExperience-dialog {
    border-radius: 5px;
    .el-dialog__body {
      padding: 20px;
      padding-top: 15px;
      padding-bottom: 56px;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
    }
    .el-button--primary {
      background: #4777e7;
      border-color: #4777e7;
    }
    .el-button--primary:hover {
      background: #7397ec;
      border-color: #7397ec;
    }
  }
}
</style>
